import { orderInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

orderInformationStyles.orderNumberTitle = {
    variant: "h6",
    as: "h3",
    css: css`
        margin-bottom: 5px;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        font-size: 12px;
                    `,
                    null,
                ],
                "max",
            )}
    `,
};
orderInformationStyles.orderDateTitle = {
    variant: "h6",
    as: "h3",
    css: css`
        margin-bottom: 5px;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        font-size: 12px;
                    `,
                    null,
                ],
                "max",
            )}
    `,
};
orderInformationStyles.poNumberTitle = {
    variant: "h6",
    as: "h3",
    css: css`
        margin-bottom: 5px;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        font-size: 12px;
                    `,
                    null,
                ],
                "max",
            )}
    `,
};
orderInformationStyles.statusTitle = {
    variant: "h6",
    as: "h3",
    css: css`
        margin-bottom: 5px;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        font-size: 12px;
                    `,
                    null,
                ],
                "max",
            )}
    `,
};
orderInformationStyles.orderInformationGridContainer = {
    gap: 15,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
orderInformationStyles.orderNumberGridItem = {
    width: [6, 3, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.orderDateGridItem = {
    width: [6, 3, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.poNumberGridItem = {
    width: [6, 3, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.statusGridItem = {
    width: [6, 3, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.mainInformationGridItem = {
    width: 10,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
